import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';

export default store => ({
  path : '/info/:permalink',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Counter = require('./containers/InfoPageContainer').default;
      let reducer;
      const sagas = require('sagas/sagas').default;

      const reducerArray = ['textInfos'];
      reducerArray.forEach((item) => {
        reducer = require(`reducers/${item}`).default; // eslint-disable-line
        injectReducer(store, { key: item, reducer });
      });

      injectSagas(store, { key: 'sagas', sagas });

      cb(null, Counter);
    }, 'infopage');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/InfoPage/index.js